var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCheck = function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.96 16.253a.599.599 0 1 1 .847.847l-3.764 3.766a.6.6 0 0 1-.85 0l-1.881-1.883a.6.6 0 0 1 .848-.848l1.458 1.458zM10.088 2.899a5.306 5.306 0 0 1 2.7 9.873 8.1 8.1 0 0 1 2.68 1.572.6.6 0 0 1-.794.9 6.93 6.93 0 0 0-4.547-1.733h-.053a6.933 6.933 0 0 0-6.915 6.93.6.6 0 0 1-1.2 0 8.13 8.13 0 0 1 5.43-7.669 5.306 5.306 0 0 1 2.7-9.873m0 1.2a4.107 4.107 0 0 0-.01 8.211h.046a4.106 4.106 0 0 0-.036-8.211"
  })));
};
export default SvgUserCheck;